import "./styles/GlobalStyles.css";
import "./App.css";
import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import posthog from "posthog-js";
import Navigation from "./shared/components/Navigation";
import ScrollToTop from "./shared/components/ScrollToTop";
import JumpPhotos from "./shared/components/JumpPhotos";
import { AdminProvider } from "./shared/context/AdminContext";
import { ThemeProvider } from "./shared/context/ThemeContext";

// Initialize PostHog
if (process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com",
    capture_pageview: false, // We'll capture manually for SPA
  });
}

// Lazy load route components for code splitting
const Home = lazy(() => import("./routes/Home"));
const Articles = lazy(() => import("./routes/Articles"));
const NewsFeed = lazy(() => import("./routes/NewsFeed"));
const NewsQueue = lazy(() => import("./routes/NewsQueue"));
const ArticleDetail = lazy(() => import("./routes/ArticleDetail"));
const Tools = lazy(() => import("./routes/Tools"));
const Suggestions = lazy(() => import("./routes/Suggestions"));
const Admin = lazy(() => import("./routes/Admin"));
const FilmPhotos = lazy(() => import("./routes/FilmPhotos"));
const Blog = lazy(() => import("./routes/Blog"));
const BlogPost = lazy(() => import("./routes/BlogPost"));

// Wrapper component to access location
const AppContent = () => {
  const location = useLocation();
  const isStandaloneTool = location.pathname.startsWith('/projects/interval-timer') || location.pathname.startsWith('/projects/workout-timer');

  // Track page views on route change
  useEffect(() => {
    posthog.capture("$pageview");
  }, [location]);

  return (
    <div>
      <ScrollToTop />
      {!isStandaloneTool && <JumpPhotos />}
      {!isStandaloneTool && <Navigation />}

      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/:id" element={<ArticleDetail />} />
          <Route path="/feed" element={<NewsFeed />} />
          <Route path="/queue" element={<NewsQueue />} />
          <Route path="/projects" element={<Tools />} />
          <Route path="/projects/:toolName/*" element={<Tools />} />
          <Route path="/suggestions" element={<Suggestions />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/film-photos" element={<FilmPhotos />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:urlWord" element={<BlogPost />} />
        </Routes>
      </Suspense>
    </div>
  );
};

const App = () => {
  return (
    <div className="App">
      <ThemeProvider>
        <Router>
          <AdminProvider>
            <AppContent />
          </AdminProvider>
        </Router>
      </ThemeProvider>
    </div>
  );
};

export default App;
